export default __webpack_public_path__ + "static/google-icon-92f728792e3664c4c7e39bd2a20614d0.png";